// pages/dealer_inventory_upload.jsx
import React, { useMemo } from "react";
import { Typography, LinearProgress, Box, makeStyles } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import PageLayout from "layouts/PageLayout";
import Table from "components/TableWrapper/TableWrapper";
import TextActionButton from "components/TextActionButton/TextActionButton";
import DealerInventoryUploadForm from "./DealerInventoryUploadForm";
import { makeTableColumns } from "./makeTableColumns";
import useDealerInventoryUpload from "hooks/useDealerInventoryUpload";
import { useConfirmationDialog } from "hooks/useConfirmationDialog";

const useStyles = makeStyles((theme) => ({
    progressContainer: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        marginBottom: theme.spacing(2),
    },
    progressText: {
        minWidth: 60,
    },
    progressMessage: {
        marginBottom: theme.spacing(1),
    },
}));

export default function DealerInventoryUpload({ ...otherProps }) {
    const classes = useStyles();
    const { openDialog, closeDialog } = useConfirmationDialog();
    const {
        makes,
        isUploading,
        progress,
        showSuccess,
        setShowSuccess,
        handleUpload,
        log,
    } = useDealerInventoryUpload();

    const columns = useMemo(() => makeTableColumns(), []);

    const handleCreateUpload = () => {
        openDialog({
            customDialog: true,
            fullWidth: true,
            maxWidth: "xs",
            message: (
                <DealerInventoryUploadForm
                    makes={makes}
                    onClose={closeDialog}
                    onConfirm={handleUpload}
                />
            ),
        });
    };

    return (
        <PageLayout
            customComponent={
                <TextActionButton onClick={handleCreateUpload}>Upload inventory</TextActionButton>
            }
            {...otherProps}
        >
            {isUploading && (
                <>
                    <Typography
                        className={classes.progressMessage}
                        variant="body2"
                        color="textSecondary"
                    >
                        Please do not close or refresh the page while the file is being processed.
                    </Typography>
                    <Box className={classes.progressContainer}>
                        <LinearProgress
                            variant="determinate"
                            value={progress}
                            style={{ flex: 1 }}
                        />
                        <Typography variant="body2" className={classes.progressText}>
                            {Math.floor(progress)}%
                        </Typography>
                    </Box>
                </>
            )}

            {showSuccess && (
                <Box mb={2}>
                    <Alert severity="success" onClose={() => setShowSuccess(false)}>
                        Upload completed. Your file is now being prepared for processing.
                    </Alert>
                </Box>
            )}

            <Table
                columns={columns}
                data={log}
                loading={false}
                pageCount={1}
                fetchData={() => {}}
            />
        </PageLayout>
    );
}
